@if (vm(); as vm) {
  <div class="p-8 relative flex flex-col justify-between items-start">
    <span class="font-semibold text-xl whitespace-pre-wrap">{{ 'shared.depot-overview-card.title' | translate }}</span>

    @if (vm.type === SiteTypeStoreModelEnum.Fleet && gridViewEnabled() && siteId(); as siteId) {
      <a [routerLink]="[RouteSegment.Root, RouteSegment.Kiosk, siteId]">
        <app-icon-button icon="tv-24" size="small" type="transparent"></app-icon-button>
      </a>
    }
  </div>

  <div class="flex">
    <div class="flex">
      @for (statusInfoUnit of statusInfo(); track statusInfoUnit.status) {
        <div class="flex items-center border-l border-stroke-primary-8 pl-[14px] min-w-[100px]">
          <div class="flex flex-col gap-4">
            @if (statusInfoUnit.type === SiteTypeStoreModelEnum.Fleet) {
              <app-vehicle-operational-status-icon
                [status]="statusInfoUnit.status"
                iconVariant="40"
                iconSize="40"
                containerClasses="w-[40px] h-[40px]"
              />
            } @else {
              <app-evse-status-icon
                [status]="statusInfoUnit.status"
                [connectorType]="statusInfoUnit.connectorType"
                iconVariant="40"
                iconSize="40"
                containerClasses="w-[40px] h-[40px]"
              />
            }

            <div class="flex flex-col">
              <div class="text-xs text-foreground-primary-80">
                @if (statusInfoUnit.type === SiteTypeStoreModelEnum.Fleet) {
                  {{ statusInfoUnit.status | appTranslateVehicleStatusCapitalized }}
                } @else {
                  {{ statusInfoUnit.status | appTranslateEvseStatusCapitalized }}
                }
              </div>
              <div class="text-2xl font-semibold">
                {{ statusInfoUnit.count }}
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="w-[250px] relative">
      @if (vm.type === SiteTypeStoreModelEnum.Fleet) {
        <app-depot-overview-chart
          [vm]="vm.chartVm"
          [label]="'shared.depot-overview-card.vehicles' | translate"
          class="absolute w-full left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
        />
      } @else {
        <app-depot-overview-chart
          [vm]="vm.chartVm"
          [label]="'shared.depot-overview-card.chargers' | translate"
          class="absolute w-full left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
        />
      }
    </div>
  </div>
}
